import { render } from "./addTraining.svg?vue&type=template&id=0aafca68"
const script = {}
script.render = render

export default script